import translate from '@translate';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import BodyTopBlock from 'src/components/BodyTopBlock';
import RemindersItem from 'src/components/RemindersItem';
import { ReceivingType } from 'src/types/receiving';
import FindInPageIcon from '@mui/icons-material/FindInPage';

export interface TopBlockPropsType {
    data: ReceivingType | null;
    idReceiving: string | undefined;
    newReceiving: boolean;
    archive?: boolean;
    disableEdit: boolean;
    permissionConfirm: boolean;
    loading: boolean;
    handleSave: () => boolean;
    activeTab: string;
    onChangeTab: (value: string) => void;
    showPdfForm: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    const navigate = useNavigate();

    const handleConfirm = () => {
        navigate(`/receivings/${props.idReceiving}/confirm/`);
    };

    return (
        <>
            <BodyTopBlock
                tabs={[
                    { value: 'detail', label: translate('receivingDetail.detail') },
                    { value: 'history', label: translate('receivingDetail.history') },
                ]}
                selectTab={!props.newReceiving ? props.activeTab : undefined}
                onChangeTab={!props.newReceiving ? props.onChangeTab : undefined}
                actions={[
                    {
                        tooltip: translate('receivingDetail.action.showPdfForm'),
                        onClick: props.showPdfForm,
                        hidden: props.archive || props.newReceiving || !props.data,
                        icon: <FindInPageIcon />,
                        variant: 'outlined',
                    },
                    {
                        onClick: handleConfirm,
                        label: translate('receivingDetail.action.confirm'),
                        hidden: props.archive || props.data?.STATUS !== 'received' || !props.permissionConfirm,
                    },
                    {
                        actionKey: 'reminders',
                        element: !props.newReceiving && !props.archive ? (
                            <RemindersItem type="receiving" idItem={props.idReceiving} />
                        ) : null,
                    },
                    {
                        label: translate(
                            props.newReceiving ? 'receivingDetail.action.create' : 'receivingDetail.action.save'
                        ),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: props.archive || props.activeTab !== 'detail',
                        disabled: props.loading,
                        'data-testid': 'receiving-save-btn',
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
